import { supabase } from '../config/supabase';
import toast from 'react-hot-toast';

export const useAdminLessons = () => {
  const createLesson = async (moduleId, lessonData) => {
    try {
      const { data, error } = await supabase
        .from('lessons')
        .insert([{ module_id: moduleId, ...lessonData }])
        .select()
        .single();

      if (error) throw error;

      toast.success('Lesson created successfully');
      return { data, error: null };
    } catch (error) {
      console.error('Error creating lesson:', error);
      toast.error('Failed to create lesson');
      return { data: null, error };
    }
  };

  const updateLesson = async (lessonId, updates) => {
    try {
      const { data, error } = await supabase
        .from('lessons')
        .update(updates)
        .eq('id', lessonId)
        .select()
        .single();

      if (error) throw error;

      toast.success('Lesson updated successfully');
      return { data, error: null };
    } catch (error) {
      console.error('Error updating lesson:', error);
      toast.error('Failed to update lesson');
      return { data: null, error };
    }
  };

  const deleteLesson = async (lessonId) => {
    try {
      const { error } = await supabase
        .from('lessons')
        .delete()
        .eq('id', lessonId);

      if (error) throw error;

      toast.success('Lesson deleted successfully');
      return { error: null };
    } catch (error) {
      console.error('Error deleting lesson:', error);
      toast.error('Failed to delete lesson');
      return { error };
    }
  };

  const reorderLessons = async (lessons, sourceIndex, destinationIndex) => {
    try {
      // Create new order
      const reorderedLessons = Array.from(lessons);
      const [removed] = reorderedLessons.splice(sourceIndex, 1);
      reorderedLessons.splice(destinationIndex, 0, removed);

      // Update order_index for all lessons
      const updates = reorderedLessons.map((lesson, index) => ({
        id: lesson.id,
        order_index: index
      }));

      for (const update of updates) {
        await supabase
          .from('lessons')
          .update({ order_index: update.order_index })
          .eq('id', update.id);
      }

      return { error: null };
    } catch (error) {
      console.error('Error reordering lessons:', error);
      toast.error('Failed to reorder lessons');
      return { error };
    }
  };

  return {
    createLesson,
    updateLesson,
    deleteLesson,
    reorderLessons
  };
};